export const configAmeyukiDh = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_NOWCAS_WX/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WX_AMEYUKI",
      "url": "%expo_tile_gpv_url%/WNI_NOWCAS_WX_%validtime%/%z%_%y%_%x%.png?latestValid=%latestValid%",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 7,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 121,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configAmeyukiLayer = {
  "Name": "RadarAmeyuki",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "alternative_color": [0, 0, 0, 0],
        "palette": [
          [0, 0, 0, 0],         // x
          [0, 0, 0, 0],         // fine
          [0, 0, 0, 0],         // cloudy
          [0, 0, 0, 0],         // rain
          [0, 255, 255, 120],   // weak rain
          [0, 0, 255, 120],     // strong rain
          [223, 82, 134, 120],  // snow
          [153, 51, 204, 120],  // sleet
          [253, 202, 202, 120], // wet weak snow
          [202, 253, 202, 120], // dry weak snow
          [202, 49, 49, 120],   // wet strong snow
          [0 ,151, 0, 120]      // dry strong snow
        ]
      }
    }
  }
};
